import classNames from 'classnames';
import { PropsWithChildren, useContext, useEffect } from 'react';

import { gradientBgClassNames } from '@utils/style';
import { IntlContext } from '@utils/useIntl';

interface OverlayProps {
  onClose: () => void;
}

const crossElClassNames =
  'absolute top-1/2 left-1/2 w-6 h-px -ml-3 bg-light group-hover:bg-accent transition-colors';

const Overlay = ({ children, onClose }: OverlayProps & PropsWithChildren) => {
  const { translate } = useContext(IntlContext);

  useEffect(() => {
    document.body.classList.add('overflow-hidden');
    return () => document.body.classList.remove('overflow-hidden');
  }, []);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <div
      className={classNames(
        gradientBgClassNames,
        'fixed top-0 right-0 bottom-0 left-0 z-10',
      )}
    >
      {/* Overlay content */}
      {children}

      {/* Close button */}
      <div className="absolute top-0 right-0 w-20 h-20 p-4 z-10">
        <button
          aria-label={translate('common.close')}
          className="group w-full h-full p-2 rotate-45 cursor-pointer"
          onClick={onClose}
        >
          <i className={crossElClassNames} />
          <i className={classNames(crossElClassNames, 'rotate-90')} />
        </button>
      </div>
    </div>
  );
};

export default Overlay;
